import React from 'react';
import OrderBookForm from '../../../components/chancemng/obtainorder/OrderBookForm';

const OrderBookFormContainer = ({ type, orderInfo, chance, formik }) => {
  if (!orderInfo) {
    return null;
  }

  return (
    <OrderBookForm
      type={type}
      orderInfo={orderInfo}
      formik={formik}
      chance={chance}
    />
  );
};

export default OrderBookFormContainer;
